// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cards_cards__znP05","fade":"Cards_fade__zFATf","card":"Cards_card__BCAKy","category":"Cards_category__6Bihl"};